import { Box, Button, Typography } from "@mui/material";
import React from "react";
import { theme } from "../../theme";
import { useNavigate } from "react-router-dom";

const CreatorsAllianceProgramPage = () => {
  const navigate = useNavigate();
  return (
    <div>
      <Box display="flex" flexDirection="column" gap="2rem">
        {/* Creators Alliance Program Header Section */}
        <Box
          sx={{
            position: "relative",
            margin: "3rem 0",
          }}
        >
          <Button
            variant="outlined"
            sx={{
              position: "absolute",
              top: "-50px",
              left: "42%",
              textTransform: "capitalize",
              fontWeight: "bold",
              color: theme.colors.white,
              borderColor: theme.colors.white,
              "&:hover": {
                backgroundColor: theme.colors.red,
                borderColor: theme.colors.red,
              },
            }}
            onClick={() =>
              navigate("/category/social-impact/community-programs")
            }
          >
            Community Programs
          </Button>

          <Typography
            variant="h1"
            sx={{ fontWeight: "700", fontSize: "4rem", textAlign: "center" }}
          >
            Join the Kbean® Creator’s Alliance Program and Elevate Your Creative
            Journey!
          </Typography>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "1rem",
              margin: "1rem 0",
            }}
          >
            <Typography variant="body1">
              By{" "}
              <Typography
                component="span"
                sx={{
                  display: "inline-block",
                  textDecoration: "none",
                  textTransform: "uppercase",
                  "&:hover": {
                    color: theme.colors.red,
                    textDecoration: "underline",
                    cursor: "pointer",
                  },
                }}
                onClick={() => navigate("/")}
              >
                kbean
              </Typography>
            </Typography>
            <span
              style={{
                height: "12px",
                width: "1px",
                borderLeft: "1px solid white",
              }}
            ></span>
            <Typography variant="body1">May 24, 2024</Typography>
            <span
              style={{
                height: "12px",
                width: "1px",
                borderLeft: "1px solid white",
              }}
            ></span>
            <Typography variant="body1">No Comments</Typography>
          </Box>
        </Box>

        <Typography variant="body1">
          Are you a passionate content creator looking to expand your reach,
          engage deeply with your audience, and join a community that values
          creativity and social impact? Look no further! Kbean’s Creator’s
          Alliance Program (CAP) is designed just for you.
        </Typography>

        <Box>
          <Typography
            variant="h2"
            sx={{
              fontWeight: "700",
              fontSize: "2rem",
            }}
          >
            What is the Creator’s Alliance Program?
          </Typography>
          <Typography variant="body1">
            Kbean’s exclusive membership program, the Creator’s Alliance Program
            (CAP), is tailored for creative content creators like you. Our
            mission is to foster a tightly-knit community where members can
            freely share their ideas and needs. We strive to create a supportive
            environment that nurtures creativity, security, and innovation while
            promoting social impact. Through CAP, you’ll connect, exchange
            knowledge, and influence the community in meaningful ways,
            strengthening bonds and enhancing collective potential.
          </Typography>
        </Box>

        {/* Exciting benefits section */}
        <Box>
          <Typography
            variant="h2"
            sx={{
              fontWeight: "700",
              fontSize: "2rem",
              marginBottom: "1rem",
            }}
          >
            Exciting Benefits of Joining CAP
          </Typography>

          <Box sx={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}>
            <Box>
              <Typography
                variant="h5"
                sx={{ fontSize: "1.2rem", fontWeight: "600" }}
              >
                1. Discount Service Fee:
              </Typography>
              <Typography variant="body1">
                Enjoy the lowest service fee and gain Kbean Ambassador status.
                Save more while maximizing your profits.
              </Typography>
            </Box>

            <Box>
              <Typography
                variant="h5"
                sx={{ fontSize: "1.2rem", fontWeight: "600" }}
              >
                2. First Topline Exposure:
              </Typography>
              <Typography variant="body1">
                Get top visibility for your artworks by hosting a virtual
                exhibit or showcasing curated items on Kbean Select. Your
                creations will be prominently featured on all mobile platforms,
                reaching a wider audience of art enthusiasts and potential
                buyers.
              </Typography>
            </Box>

            <Box>
              <Typography
                variant="h5"
                sx={{ fontSize: "1.2rem", fontWeight: "600" }}
              >
                3. Pricing and Editions Customization:
              </Typography>
              <Typography variant="body1">
                Enjoy full flexibility to set custom prices and edition numbers
                for each piece of content—privileges unavailable to non-members.
              </Typography>
            </Box>

            <Box>
              <Typography
                variant="h5"
                sx={{ fontSize: "1.2rem", fontWeight: "600" }}
              >
                4. Spotlight Artists:
              </Typography>
              <Typography variant="body1">
                Highlight your profile and elevate your portfolio, connecting
                with a wider community that follows you.
              </Typography>
            </Box>

            <Box>
              <Typography
                variant="h5"
                sx={{ fontSize: "1.2rem", fontWeight: "600" }}
              >
                5. Fan Club Creation:
              </Typography>
              <Typography variant="body1">
                Set up and cultivate your fan club with a subscription model.
                Only subscribed members will have access to your exclusive
                content and challenges, allowing you to engage deeply with your
                most dedicated fans. Offer them unique insights, special
                updates, and interactive experiences while generating a steady
                stream of income.
              </Typography>
            </Box>

            <Box>
              <Typography
                variant="h5"
                sx={{ fontSize: "1.2rem", fontWeight: "600" }}
              >
                6. Exclusive Invitations:
              </Typography>
              <Typography variant="body1">
                Gain early, complimentary, or upgraded access to select events
                or film festivals hosted by Kbean, with Ambassador designation.
              </Typography>
            </Box>

            <Box>
              <Typography
                variant="h5"
                sx={{ fontSize: "1.2rem", fontWeight: "600" }}
              >
                7. Speaker or Presenter Opportunities:
              </Typography>
              <Typography variant="body1">
                Share your passion at Kbean-hosted or sponsored meetings,
                conferences, or events. Inspire others with your dedication to
                social impact.
              </Typography>
            </Box>

            <Box>
              <Typography
                variant="h5"
                sx={{ fontSize: "1.2rem", fontWeight: "600" }}
              >
                8. Network with Social Influencers:
              </Typography>
              <Typography variant="body1">
                Network with social influencers and non-profit business leaders
                who share the same social impact purpose. Exchange ideas, gain
                support, and build a community dedicated to making a positive
                difference.
              </Typography>
            </Box>
          </Box>
        </Box>

        {/* Membership Cost */}
        <Box>
          <Typography
            variant="h2"
            sx={{
              fontWeight: "700",
              fontSize: "2rem",
            }}
          >
            Membership Cost
          </Typography>
          <Typography variant="body1">
            The membership fee for one year is just $360. This investment opens
            doors to a world of opportunities, connections, and growth.
          </Typography>
        </Box>

        {/* Action Buttons Section  */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            margin: "2rem 0",
          }}
        >
          <Button
            sx={{
              padding: "1rem 2rem",
              fontWeight: "600",
              textTransform: "capitalize",
              backgroundColor: theme.colors.blue,
              fontSize: "1.2rem",
              color: theme.colors.white,
              "&:hover": {
                backgroundColor: theme.colors.blue,
                opacity: "0.9",
              },
            }}
            onClick={() => navigate(-1)}
          >
            Go Back
          </Button>

          <Button
            sx={{
              padding: "1rem 2rem",
              fontWeight: "600",
              textTransform: "uppercase",
              backgroundColor: theme.colors.red,
              fontSize: "1.2rem",
              color: theme.colors.white,
              "&:hover": {
                backgroundColor: theme.colors.red,
                opacity: "0.9",
              },
            }}
            onClick={() => navigate("/challenge/memberships/cap")}
          >
            JOIN THE KBEAN CREATORS ALLIANCE PROGRAM
          </Button>
        </Box>

        {/* Get in touch section */}
        <Box>
          <Typography
            variant="h2"
            sx={{
              fontWeight: "700",
              fontSize: "2rem",
            }}
          >
            Get in Touch
          </Typography>
          <Typography variant="body1">
            For more information or any queries, feel free to reach out to us
            at:
          </Typography>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "1rem",
              marginTop: "1rem",
            }}
          >
            <Box>
              <Typography
                variant="h5"
                sx={{ fontSize: "1.2rem", fontWeight: "600" }}
              >
                Address:
              </Typography>
              <Typography variant="body1">
                166 Geary St. Suite 1500 – #1202 <br />
                San Francisco, CA 94108
              </Typography>
            </Box>

            <Box>
              <Typography
                variant="h5"
                sx={{ fontSize: "1.2rem", fontWeight: "600" }}
              >
                Phone:
              </Typography>
              <Typography variant="body1">+1 415 323 0006</Typography>
            </Box>

            <Box>
              <Typography
                variant="h5"
                sx={{ fontSize: "1.2rem", fontWeight: "600" }}
              >
                Website:
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  color: theme.colors.red,
                  textDecoration: "none",
                  ":hover": {
                    color: theme.colors.red,
                    cursor: "pointer",
                    textDecoration: "underline",
                  },
                }}
                onClick={() => navigate("/")}
              >
                www.kbean.com
              </Typography>
            </Box>
          </Box>
        </Box>

        <Typography
          variant="body1"
          sx={{ borderTop: `1px solid white`, paddingTop: "0.5rem" }}
        >
          Join the Kbean Creator’s Alliance Program today and be part of a
          community where creativity meets impact. Let’s make a difference
          together!
        </Typography>
      </Box>
    </div>
  );
};

export default CreatorsAllianceProgramPage;
